import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { Organization } from '@utils/types/organization/organization.ts';

export function updateOrganization(
  organizationData: Organization
): Promise<void> {
  return Axios.post(POST_URL().updateOrganization, organizationData).then(
    () => {}
  );
}

export function useUpdateOrganization() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, Organization>(
    updateOrganization,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['organization']);
      },
      useErrorBoundary: false
    }
  );
}
